/*------------------------------------------------------------------
[React]
-------------------------------------------------------------------*/
import React, {useEffect, useState} from "react";
/*------------------------------------------------------------------
[End React]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[API]
-------------------------------------------------------------------*/
import { API_URL, API_SCT, API_SERVER } from '../../api';
/*------------------------------------------------------------------
[End API]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Module]
-------------------------------------------------------------------*/
import axios from 'axios'
import {reactLocalStorage} from 'reactjs-localstorage';
import ReactLoading from 'react-loading';
/*------------------------------------------------------------------
[End Module]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[React Router]
-------------------------------------------------------------------*/
import { NavLink } from "react-router-dom";
/*------------------------------------------------------------------
[End React Router]
-------------------------------------------------------------------*/

const Screen = ({loading, error, progress}) => {

    /*--------------------------------------------------------------
    [Storage]
    ----------------------------------------------------------------*/
    let STORAGE_TOKEN = reactLocalStorage.get('@token');

    let STORAGE_USER_STRINGIFY = reactLocalStorage.get('@user');

	let STORAGE_USER;

	if(STORAGE_USER_STRINGIFY){
		STORAGE_USER = JSON.parse(STORAGE_USER_STRINGIFY)
	}
    /*--------------------------------------------------------------
    [End Storage]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [State]
    ----------------------------------------------------------------*/
    const [refresh, set_refresh] = useState(null);
    const [image_progress, set_image_progress] = useState(false)
    const [data, set_data] = useState(null)
    const [quality, set_quality] = useState(50)
    const [tab, set_tab] = useState('jpg')
    /*--------------------------------------------------------------
    [End State]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [API]
    ----------------------------------------------------------------*/

    const _compressor = (fileParams) => {

        console.log('fileParams', fileParams)

        if(loading === true){
            return
        }

        loading(true);

        var data = new FormData();
        data.append("sct", API_SCT);
        data.append("key", STORAGE_USER[0].id_key);
        data.append("bamboo_user", STORAGE_USER[0].bamboo);
        data.append("quality", quality);

        fileParams.map((item) => (
            data.append("file", item)
        ))

        let url;

        if(tab === 'jpg'){
            url = "compress/jpg__________";
        }else if(tab === 'png'){
            url = "compress/png__________";
        }else if(tab === 'svg'){
            url = "compress/svg__________";
        }
        // else if(tab === 'gif'){
        //     url = "compress/gif__________";
        // }
        // else if(tab === 'webp'){
        //     url = "compress/webp__________";
        // }
        else{
            url = null
        }

        console.log('url : ', url)

        var config = {
            method: 'post',
            url: API_URL + url,
            headers: { 
                'Authorization': `Bearer ${STORAGE_TOKEN}`,
            },
            data : data,
            onUploadProgress: progressEvent => {
                console.log('loaded : ', progressEvent.loaded)
                console.log('total : ', progressEvent.total)
                set_image_progress(true)
                progress(parseInt(Math.round((progressEvent.loaded/progressEvent.total) * 100)))
            }
        };

        axios(config)
        .then((response) => {
            if(response.data.result === 'success'){
                set_data(response.data.data)
                error(response.data.title)
                set_image_progress(false)
                document.getElementById("compress").value = "";
            } else if(response.data.error){
                error(response.data.error)
                set_image_progress(false)
                document.getElementById("compress").value = "";
            }
        })
        .catch((e) => {
            console.log('catch : ', e)
            error(e.message)
            set_image_progress(false)
            document.getElementById("compress").value = "";
        })
        .finally(() => {
            loading(false);
            set_image_progress(false)
            document.getElementById("compress").value = "";
		})

    }

    /*--------------------------------------------------------------
    [End API]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [FILES]
    ----------------------------------------------------------------*/
    const _files_image = (event) => {

        if(STORAGE_USER === undefined){
            document.getElementById("compress").value = "";
            return error('Login Terlebih Dahulu')
        }

        if(!event){
            return error('Terjadi Kesalahan')
        }
        
        const data = [...event.target.files]
        
        if(data){
            console.log('data', data)
            if(data.length > 0){
                
                data.map((item, index) => {
                    // console.log('item', data)
                    if(item.size > 10485760){
                        return error('Ukuran File maxsimal 10MB')
                    }else{
                        error('')
                        set_data(null)
                        _compressor([...data])
                    }

                })

            }
        }

        // let foo = event.target.files[0]; 

	};
    /*--------------------------------------------------------------
    [End FILES]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [useEffect]
    ----------------------------------------------------------------*/
    useEffect(() => {


    }, [refresh, tab])
    /*--------------------------------------------------------------
    [End useEffect]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Render]
    ----------------------------------------------------------------*/
    return (
        <div style={{margin: -20}}>
            {
                image_progress ?
                <div style={{position: 'fixed', top: 0, right: 0, bottom: 0, left: 0, zIndex: 999999, backgroundColor: '#fff', padding: 20}}>
                    <div className="_position_middle">
                        <div className="_center_align">
                            <ReactLoading type={'cylon'} color={'#444'} height={40} width={40} />
                        </div>
                        <h1 className="_push_b_m">Compress</h1>
                        <div className="_center_text" style={{maxWidth: 400, marginLeft: 'auto', marginRight: 'auto'}}>
                            <p>File Sedang Dikompresi . . .</p>
                        </div>
                    </div>
                </div>
                : null
            }
            <div style={{overflow: 'hidden', padding: 20}}>

                <div style={{zIndex: 3, position: 'relative'}}>
                    <h1 style={{marginBottom: 20}}><span style={{color: '#118ab2'}}>e-</span>Compress Image</h1>
                    <div className="_row _center_align _push_b_g">
                        <ion-icon name="leaf-outline" style={{fontSize: 20}}></ion-icon>
                        <p className="_push_l_m">Kompresi File Menjadi Lebih Kecil</p>
                    </div>
                    <div className="_overflow_x _push_b_d">
                        <div className="_row _center_align">
                            <span onClick={() => {set_tab('jpg')}} style={{backgroundColor: tab === 'jpg' ? 'seagreen' : '#fff', color: tab === 'jpg' ? '#fff' : 'inherit'}} className="_btn _cursor_pointer _push_r_m">jpg</span>
                            <span onClick={() => {set_tab('png')}} style={{backgroundColor: tab === 'png' ? 'seagreen' : '#fff', color: tab === 'png' ? '#fff' : 'inherit'}} className="_btn _cursor_pointer _push_r_m">png</span>
                            {/* <span onClick={() => {set_tab('gif')}} style={{backgroundColor: tab === 'gif' ? 'seagreen' : '#fff', color: tab === 'gif' ? '#fff' : 'inherit'}} className="_btn _cursor_pointer _push_r_m">gif</span> */}
                            {/* <span onClick={() => {set_tab('svg')}} style={{backgroundColor: tab === 'svg' ? 'seagreen' : '#fff', color: tab === 'svg' ? '#fff' : 'inherit'}} className="_btn _cursor_pointer _push_r_m">svg</span> */}
                            {/* <span onClick={() => {set_tab('webp')}} style={{backgroundColor: tab === 'webp' ? 'seagreen' : '#fff', color: tab === 'webp' ? '#fff' : 'inherit'}} className="_btn _cursor_pointer _push_r_m">webP</span> */}
                        </div>
                    </div>
                </div>
                <div className="_overflow_x">

                    <div className="_row _center_align _push_b_d _relative" style={{zIndex: 10, minWidth: 650}}>
                        <div className="_push_r_d">
                            <p>Quality</p>
                        </div>
                        <div className="_column">
                            <div className="_row _center_align">
                                <div className="_cursor_pointer" onClick={() => {set_quality(10)}} style={{backgroundColor: quality === 10 ? 'seagreen' : '#fff', display: 'inline-block', height: 20, width: 20, borderRadius: 30, borderWidth: 1, borderColor: '#ccc', borderStyle: 'solid'}}>

                                </div>
                                <p className="_push_l_t _push_t_t" style={{fontSize: 12}}>10%</p>
                            </div>
                        </div>
                        <div className="_column">
                            <div className="_row _center_align">
                                <div className="_cursor_pointer" onClick={() => {set_quality(20)}} style={{backgroundColor: quality === 20 ? 'seagreen' : '#fff', display: 'inline-block', height: 20, width: 20, borderRadius: 30, borderWidth: 1, borderColor: '#ccc', borderStyle: 'solid'}}>

                                </div>
                                <p className="_push_l_t _push_t_t" style={{fontSize: 12}}>20%</p>
                            </div>
                        </div>
                        <div className="_column">
                            <div className="_row _center_align">
                                <div className="_cursor_pointer" onClick={() => {set_quality(30)}} style={{backgroundColor: quality === 30 ? 'seagreen' : '#fff', display: 'inline-block', height: 20, width: 20, borderRadius: 30, borderWidth: 1, borderColor: '#ccc', borderStyle: 'solid'}}>

                                </div>
                                <p className="_push_l_t _push_t_t" style={{fontSize: 12}}>30%</p>
                            </div>
                        </div>
                        <div className="_column">
                            <div className="_row _center_align">
                                <div className="_cursor_pointer" onClick={() => {set_quality(40)}} style={{backgroundColor: quality === 40 ? 'seagreen' : '#fff', display: 'inline-block', height: 20, width: 20, borderRadius: 30, borderWidth: 1, borderColor: '#ccc', borderStyle: 'solid'}}>

                                </div>
                                <p className="_push_l_t _push_t_t" style={{fontSize: 12}}>40%</p>
                            </div>
                        </div>
                        <div className="_column">
                            <div className="_row _center_align">
                                <div className="_cursor_pointer" onClick={() => {set_quality(50)}} style={{backgroundColor: quality === 50 ? 'seagreen' : '#fff', display: 'inline-block', height: 20, width: 20, borderRadius: 30, borderWidth: 1, borderColor: '#ccc', borderStyle: 'solid'}}>

                                </div>
                                <p className="_push_l_t _push_t_t" style={{fontSize: 12}}>50%</p>
                            </div>
                        </div>
                        <div className="_column">
                            <div className="_row _center_align">
                                <div className="_cursor_pointer" onClick={() => {set_quality(60)}} style={{backgroundColor: quality === 60 ? 'seagreen' : '#fff', display: 'inline-block', height: 20, width: 20, borderRadius: 30, borderWidth: 1, borderColor: '#ccc', borderStyle: 'solid'}}>

                                </div>
                                <p className="_push_l_t _push_t_t" style={{fontSize: 12}}>60%</p>
                            </div>
                        </div>
                        <div className="_column">
                            <div className="_row _center_align">
                                <div className="_cursor_pointer" onClick={() => {set_quality(70)}} style={{backgroundColor: quality === 70 ? 'seagreen' : '#fff', display: 'inline-block', height: 20, width: 20, borderRadius: 30, borderWidth: 1, borderColor: '#ccc', borderStyle: 'solid'}}>

                                </div>
                                <p className="_push_l_t _push_t_t" style={{fontSize: 12}}>70%</p>
                            </div>
                        </div>
                        <div className="_column">
                            <div className="_row _center_align">
                                <div className="_cursor_pointer" onClick={() => {set_quality(80)}} style={{backgroundColor: quality === 80 ? 'seagreen' : '#fff', display: 'inline-block', height: 20, width: 20, borderRadius: 30, borderWidth: 1, borderColor: '#ccc', borderStyle: 'solid'}}>

                                </div>
                                <p className="_push_l_t _push_t_t" style={{fontSize: 12}}>80%</p>
                            </div>
                        </div>
                        <div className="_column">
                            <div className="_row _center_align">
                                <div className="_cursor_pointer" onClick={() => {set_quality(90)}} style={{backgroundColor: quality === 90 ? 'seagreen' : '#fff', display: 'inline-block', height: 20, width: 20, borderRadius: 30, borderWidth: 1, borderColor: '#ccc', borderStyle: 'solid'}}>

                                </div>
                                <p className="_push_l_t _push_t_t" style={{fontSize: 12}}>90%</p>
                            </div>
                        </div>
                    </div>
                    
                </div>
                <div className="_bb_file_uploads" style={{height: 400}}>
                    <div style={{position: 'absolute', top: 10, right: 10, bottom: 10, left: 10, zIndex: -1, backgroundColor: '#f9f9fa'}}>
                        <div className="_position_middle">
                            <ion-icon name="balloon-outline" style={{fontSize: 100}}></ion-icon>
                            <p className="_push_t_d">Pilih Data atau drop disini</p>
                        </div>
                    </div>
                    <input
                        id="compress"
                        multiple
                        className="_custom_file_input_drop" 
                        type="file"
                        name="file"
                        placeholder=""
                        onChange={_files_image}
                    />
                </div>
                <br/>
                <div className="_row_auto _center_align">
                    {
                        data && data.length > 0 &&
                        data.map((item, index) => (
                            <a target={'_blank'} href={API_SERVER + '/' + 'modify/' + STORAGE_USER[0].bamboo + '/' + item} className="_btn _push_r_m _push_b_s">
                                <div className="_row _center_align">
                                    <ion-icon name="cloud-download-outline" style={{fontSize: 18, marginRight: 10}}></ion-icon> 
                                    <div>
                                        File {index + 1}
                                    </div>
                                </div>
                            </a>

                        ))   
                    }
                </div>
            
            </div>
        </div>
    );
    /*--------------------------------------------------------------
    [End Render]
    ----------------------------------------------------------------*/

}

export default Screen;